import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_317: DocMigration = {
  maxSchemaVersion: "0.0.317",
  description: "Move optionSetRefs and builderRefs to lastSessionInfo.",
  apply(json: any): any {
    const { optionSetRefs, builderRefs } = json;
    if (!json.lastSessionInfo) {
      json.lastSessionInfo = {};
    }
    json.lastSessionInfo.optionSetRefs = optionSetRefs ?? {};
    delete json.optionSetRefs;
    json.lastSessionInfo.builderRefs = builderRefs ?? {};
    delete json.builderRefs;

    return json;
  },
};

export default migration_0_0_317;
